import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch} from 'react-router-dom';
import axios from 'axios';
import Login from './pages/auth/Login';
import setAuthToken from './utils/setAuthToken';
import { logoutUser } from './api/web';
import {SET_AUTH_USER} from './stores/auth';
import Private from "./components/routes/Private";
import Logout from "./pages/auth/Logout";
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap';
import $ from './utils/jquery';
import { handleUnauthorized } from './utils/handleUnauthorized';

import store from './stores';

let unauthorizedHandlersRegistered = false;

if (!unauthorizedHandlersRegistered) {
  unauthorizedHandlersRegistered = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        handleUnauthorized(error?.config?.url || '');
      }
      return Promise.reject(error);
    }
  );

  // DataTables and other legacy code use jQuery $.ajax, not axios.
  $(document).ajaxError((_event, jqXHR, settings) => {
    if (jqXHR?.status === 401) {
      handleUnauthorized(settings?.url || '');
    }
  });
}

// Check for token (login stores under 'token'; support 'jwtToken' for backwards compat)
const token = localStorage.getItem('token') || localStorage.getItem('jwtToken');
if (token && typeof token === 'string' && token.length > 0) {
  setAuthToken(token);

  // Keep session on refresh for non-JWT tokens (e.g. Knox).
  // Actual user profile is loaded by page-level getCurrentUser() calls.
  store.dispatch(SET_AUTH_USER({ user: null, token, isAuthenticated: true }));

  // Optional expiry handling only when token looks like JWT.
  const looksLikeJwt = token.split('.').length === 3;
  if (looksLikeJwt) {
    try {
      const decodedPayload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      if (decodedPayload?.exp && decodedPayload.exp < currentTime) {
        store.dispatch(logoutUser());
        window.location.replace(`${window.location.pathname}${window.location.search}#/`);
      }
    } catch (err) {
      // If JWT parsing fails, do not force logout.
    }
  }
}

class App extends Component {
  render() {
    return (
        <Provider store={ store }>
          <Router>
            <div className="App">
              <Switch>
                <Route exact path="/" component={Login} />
                <Route exact path="/logout" component={Logout} />
                <Route component={Private} />
              </Switch>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </div>
          </Router>
        </Provider>
    );
  }
}

export default App;
